<template>
  <div>
    <div v-loading="loading" element-loading-spinner="particle-loader">
      <template>
        <el-row>
          <div style="float: right; margin: 0px 10px 10px 0px;">
            <el-input prefix-icon="el-icon-search" size="mini" placeholder="Search Query.." type="text"
              class="globalSearch" v-model="filterCriteria"></el-input>
          </div>
        </el-row>
        <el-row>
          <el-table :data="isIE11 ? codingLogsPagination : filteredCodingLogs" height="400px"
            @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55" :default-sort="{prop: 'consultantName', order: 'descending'}">
            </el-table-column>
            <el-table-column prop="consultantName" label="Coder" sortable></el-table-column>
            <el-table-column prop="serviceDate" label="Work Date" sortable>
              <template slot-scope="scope">
                {{ formatDate(scope.row.serviceDate) }}
              </template>
            </el-table-column>
            <el-table-column prop="recordType" label="Record Type" sortable></el-table-column>
            <el-table-column label="Actions">
              <template slot-scope="scope">
                <el-button size="mini"
                  @click="handleView(scope.row.adAcct, scope.row.serviceDate, scope.row.recordType)">
                  View</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination class="pager" v-if="isIE11" background :pager-count="15" layout="prev, pager, next, slot"
            :page-size="itemsPerPage" :total="codingLogs.length" @current-change="handleCurrentChange"
            :hide-on-single-page="hideOnSinglePage" small>
          </el-pagination>
          <el-button @click="generateZip()">Generate Zip For {{this.multipleSelection.length}} Selected Records
          </el-button>
        </el-row>

      </template>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import { format, parseISO } from 'date-fns'
  import hiaFilters from '@/mixins/hiaFilters'

  export default {
    name: 'CodingLogs',
    mixins: [hiaFilters],
    props: {
      dateRange: { type: Array },
      isOpen: { type: Boolean }
    },
    data: function () {
      return {
        loading: false,
        currentPage: 1,
        itemsPerPage: 30,
        // isIE11: !!navigator.userAgent.match(/Trident\/7\./),
        isIE11: false, // disabled pagination in IE11 so selectAll would work. Perfomance Seems Ok
        hideOnSinglePage: true,
        multipleSelection: [],
        zipFile: {},
        filterCriteria: ''
      }
    },
    methods: {
      ...mapActions('dashboard/', ['GET_CODINGLOGLIST', 'GET_CODINGLOG_ZIP', 'GET_CODINGLOG_PDF_URL']),
      initialize() {
        this.loading = true
        this.multipleSelection = []
        let param = {
          startDate: this.dateRange[0],
          endDate: this.dateRange[1]
        }
        this.GET_CODINGLOGLIST(param).then(response => {
          this.loading = false
        })
      },
      handleView(consultantNumber, date, serviceType) {
        const loading = this.$loading({
          lock: true,
          text: 'Getting ready...',
          spinner: 'nucleus-loader',
          background: 'rgba(255, 255, 255, 0.7)'
        })
        let param = {
          consultantNumber: consultantNumber,
          date: date,
          serviceType: serviceType
        }
        this.GET_CODINGLOG_PDF_URL(param).then(response => {
          loading.close()
          window.open(`/static/pdfjs/web/viewer.html?file=${response}`, '_blank')
        })
      },
      openPDFViewer(newWindow, worksheet) {
        var byteCharacters = atob(worksheet)
        var byteNumbers = new Array(byteCharacters.length)
        for (var i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        var byteArray = new Uint8Array(byteNumbers)
        var blob = new Blob([byteArray], {
          type: 'application/pdf'
        })
        var url = window.URL.createObjectURL(blob)
        var viewerUrl = '/static/pdfjs/web/viewer.html?file=' + encodeURI(url)
        newWindow.location.href = viewerUrl
      },
      formatDate(date) {
        return format(parseISO(date), 'MM/dd/yyyy')
      },
      handleCurrentChange(val) {
        this.currentPage = val
      },
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      generateZip() {
        this.loading = true
        let selectedLogs = []
        this.multipleSelection.forEach(element => {
          let clSelected = {
            id: element.id,
            type: element.recordType
          }
          selectedLogs.push(clSelected)
        })
        let param = {
          logs: selectedLogs
        }
        this.GET_CODINGLOG_ZIP(param).then(response => {
          this.multipleSelection = []
          this.loading = false
          this.generateDownloadLink(response.data)
        }, error => {
          console.log(error)
        })
      },
      generateDownloadLink(href) {
        let link = document.createElement('a')
        link.setAttribute('style', 'display: hidden;')
        link.setAttribute('download', 'download')
        link.id = 'hiddenLink'
        link.href = `${process.env.VUE_APP_API_BASE_URL}${href}`
        document.getElementsByTagName('body')[0].appendChild(link)
        document.getElementById('hiddenLink').click()
        // remove link
        let timerId = setInterval(() => {
          document.getElementById('hiddenLink').remove()
          clearInterval(timerId)
        }, 500)
      }
    },
    created: function () {
      this.initialize()
    },
    computed: {
      ...mapState('user/', ['currentClient', 'currentClientId']),
      ...mapState('dashboard/', ['codingLogs', 'codingLog']),
      codingLogsPagination() {
        let length = this.codingLogs.length
        let from = length <= this.itemsPerPage ? 0 : ((this.currentPage - 1) * this.itemsPerPage) + 1
        let to = this.currentPage * this.itemsPerPage
        return this.codingLogs.slice(from, to)
      },
      filteredCodingLogs() {
        return this.filterList(this.codingLogs, this.filterCriteria)
      }
    },
    watch: {
      isOpen() {
        this.initialize()
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
